import { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ onSearch, value = '' }) => {
  const [searchQuery, setSearchQuery] = useState(value);

  useEffect(() => {
    setSearchQuery(value);
  }, [value]);

  const handleSearch = (e) => {
    e?.preventDefault();
    onSearch(searchQuery?.trim() || '');
  };

  const handleChange = (e) => {
    const value = e?.target?.value ?? '';
    setSearchQuery(value);
    if (!value?.trim()) {
      onSearch('');
    }
  };

  return (
    <div className="w-full pt-32 mt-[-82px]">
      <form onSubmit={handleSearch} className="relative">
        <div className="relative">
          <Input
            type="search"
            placeholder="ابحث.."
            value={searchQuery}
            onChange={handleChange}
            className="w-full pr-12 pl-4 py-3 text-sm rounded-full bg-[var(--color-card)] border-2 border-[var(--color-border)] focus:border-[var(--color-accent)] transition-all -mt-7 -mb-1" />

          <button
            type="submit"
            className="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-[var(--color-accent)] hover:bg-[var(--color-primary)] transition-colors flex items-center justify-center"
            aria-label="بحث">

            <Icon name="Search" size={16} color="var(--color-accent-foreground)" />
          </button>
        </div>
      </form>
    </div>);

};

export default SearchBar;